function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_851",
  "data-name": "Group 851",
  transform: "translate(-196.671 107.624)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_850",
  "data-name": "Group 850"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_849",
  "data-name": "Group 849"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1729",
  "data-name": "Rectangle 1729",
  width: 41.235,
  height: 41.235,
  transform: "translate(196.671 -107.624)",
  fill: "none"
}))));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_516",
  "data-name": "Path 516",
  d: "M210.072-95.425a6.873,6.873,0,0,1,6.873-6.873,6.873,6.873,0,0,1,6.872,6.873,6.872,6.872,0,0,1-6.872,6.872A6.873,6.873,0,0,1,210.072-95.425Zm12.725,18.5a2.578,2.578,0,0,1-1.243.689l-2.369.546a2.557,2.557,0,0,1-.583.067,2.56,2.56,0,0,1-2.014-.975,2.56,2.56,0,0,1-.494-2.182l.547-2.369a2.573,2.573,0,0,1,.689-1.243l2.721-2.722H211.81c-3.84.385-7.376,3.714-6.837,7.635a42.482,42.482,0,0,0,1.3,4.827,1.826,1.826,0,0,0,1.74,1.282h17.865a1.824,1.824,0,0,0,1.74-1.282,42.511,42.511,0,0,0,1.3-4.827,6.039,6.039,0,0,0-1.163-4.4Zm11.075-14.72L232.05-93.47a.857.857,0,0,0-.608-.252.855.855,0,0,0-.607.252l-8.4,8.4-3.891,3.892a.856.856,0,0,0-.23.414l-.547,2.369a.86.86,0,0,0,.834,1.053.846.846,0,0,0,.2-.023l2.369-.546a.864.864,0,0,0,.414-.23l12.29-12.29A.858.858,0,0,0,233.872-91.648Z",
  transform: "translate(-196.671 107.624)"
});

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "blk_icon",
    id: "Icons_edit-contact",
    "data-name": "Icons / edit-contact",
    width: 41.235,
    height: 41.235,
    viewBox: "0 0 41.235 41.235",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.13a41d20.svg";
export { ForwardRef as ReactComponent };